import getInvoiceShopsSymbols from '../symbols/getInvoiceShops';
import { HttpRequestGet } from "../../service";
const getInvoiceShopsAction = () => ({
  type: getInvoiceShopsSymbols.GET_INVOICE_SHOPS,
});
const getInvoiceShopsSuccessAction = (data: any) => ({
  type: getInvoiceShopsSymbols.GET_INVOICE_SHOPS_SUCCESS,
  payload: data,
});
const getInvoiceShopsFailureAction = (data: any) => ({
  type: getInvoiceShopsSymbols.GET_INVOICE_SHOPS_FAILURE,
  payload: data,
});
const clearGetInvoiceShopsAction = () => ({
  type: getInvoiceShopsSymbols.CLEAR_GET_INVOICE_SHOPS,
});
export function getInvoiceShops(isAdmin: boolean, callback?: Function) {
  let url = isAdmin ? '/admin/invoice/shop': '/merchant/invoice/shop';
  return (dispatch: any) => {
    dispatch(getInvoiceShopsAction());
    HttpRequestGet(
      url,
      dispatch,
      getInvoiceShopsSuccessAction,
      getInvoiceShopsFailureAction,
      true,
      callback
    );
  };
}

export function clearInvoiceShops() {
  return (dispatch: any) => {
    dispatch(clearGetInvoiceShopsAction());
  };
}
